import * as actionTypes from "../actionTypes";
import Cookies from "js-cookie";
import axios from "../../../axios/axios_visitortag";
import axiosTags from "../../../axios/axios_tag";
import axiosEventTags from "../../../axios/axios_eventtag";
import axios_authentication from "../../../axios/axios_authorization";
import {notifyMessage} from "../../../const/Common/CommonFunc";
import * as config from "../../../const/config/config";
import * as qs from "qs";
import swal from "sweetalert";
import are_you_sure_icon from "../../../assets/img/sweet/question.svg";
import apiConfig from '../../../axios/axios_api_services';
// import {callAllWifiPackages, checkErrorResponse, receptionAllBuildingHandler} from "../Reception_SheduleMeetingActions";
import {callAllCount} from "../Reception_VisitorCountActions";
import {callAllBuildingsForHost} from "../Host/HostActions";

export const eventQuestionsHandler = (data) => {
  return {
    type: actionTypes.EVENT_PARTICIPANT_QUESTION,
    value: data
  }
};

export const eventQuestionsUpdateTimeHandler = (data) => {
  return {
    type: actionTypes.EVENT_PARTICIPANT_QUESTION_UPDATE_TIME,
    value: data
  }
};

// --------------------- Event handling in Redux Store ----------------------

// save all event category to redux store
export const eventAllCatogariesHandler = (data) => {

  return {
    type: actionTypes.ALL_EVENT_CATOGARIES,
    value: data
  }
};

export const callAllEventCatogaries = () => {

  const headers = {
    "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8"),
    "Content-Type": "application/json"
  };

  // Get All Event Catogaries
  return dispatch => {
    axiosEventTags.get(apiConfig.EVENT_CATOGARIES,{headers: headers})
      .then(response => {
        if (response.data.success) {
          dispatch(eventAllCatogariesHandler(response.data.category));
        }
      })
      .catch(error => {
        dispatch(checkErrorResponseEvent(error, 1));
      });
  }

};

export const storeEventDetailsHandler = (data) => {

  return {
    type: actionTypes.STORE_EVENT_DETAILS,
    value: data
  }
};

export const storeSubEventDetailsHandler = (data) => {

  return {
    type: actionTypes.STORE_SUB_EVENT_DETAILS,
    value: data
  }
};

export const deleteSubEventHandler = (data) => {

  return {
    type: actionTypes.DELETE_SUB_EVENT,
    value: data
  }
};

export const updateSubEventHandler = (data) => {

  return {
    type: actionTypes.UPDATE_SUB_EVENT,
    value: data
  }
};

export const navigationChangeHandler = (data) => {

  return {
    type: actionTypes.CHANGE_CREATE_EVENT_STEP,
    value: data
  }
};

export const stepActivateionEventHandler = (data) => {

  return {
    type: actionTypes.CHANGE_ACTIVATION_OF_STEP,
    value: data
  }
};
export const addAgendaHandler = (data) => {

  return {
    type: actionTypes.ADD_AGENDA,
    value: data
  }
};


export const changeSubEventHandler = (data) => {
  return {
    type: actionTypes.CHANGE_HAS_SUB_EVENTS,
    value: data
  };
};

export const setCurrentEventData = (data) => {

    return {
      type: actionTypes.SET_CURRENT_EVENT_DATA,
      value: data
    }

  };

export const setCurrentSubEventsData = (data) => {

  return {
    type: actionTypes.SET_CURRENT_SUB_EVENTS_DATA,
    value: data
  }

};

export const setCurrentSubEvent = (data) => {

  return {
    type: actionTypes.SET_CURRENT_SUB_EVENT,
    value: data
  };
};

export const setCurrentSubEventId = (data) => {

  return {
    type: actionTypes.SET_CURRENT_SUB_EVENT_ID,
    value: data
  };
};

export const checkErrorResponseEvent = (error, type) => {
  if (error !== undefined) {
    if (error.response === undefined) {
      notifyMessage("Your connection was interrupted!", 1, 3);
      return dispatch => {
        dispatch(emptyFunction);
      }
    } else if (error.response.status === 401) {
      const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        "Authorization": "Basic " + config.CLIENT_SECRET
      };
      let refresh_token = Cookies.get('9b8558ba3f051677daf36ebfc67f29fa');

      const data_ = {
        grant_type: "refresh_token",
        refresh_token: refresh_token
      };

      // Get Access token from refresh token
      return dispatch => {
        axios_authentication.post(apiConfig.OAUTH, qs.stringify(data_), {headers: headers})
          .then(response => {
            Cookies.set('68a6102f6ed24899420170004a0273b8', response.data.access_token); //access-token (68a6102f6ed24899420170004a0273b8)
            if (type === 1) {
              dispatch(callAllEventCatogaries());
            }
          })
          .catch(error => {

            swal({
              title: "Your token expired! Please re-enter login credentials \n Thank you",
              icon: are_you_sure_icon,
              closeOnClickOutside: false,
              buttons: {
                dangerMode: {
                  text: "Okay",
                  value: "action",
                  className: "warning-btn"
                }
              },
            })
              .then((value) => {
                switch (value) {

                  case "action":
                    Cookies.remove("68a6102f6ed24899420170004a0273b8");
                    Cookies.remove("9b8558ba3f051677daf36ebfc67f29fa");
                    window.location.href = "/host/login";

                    break;
                  default:
                }
              });
          });
      }
    } else if (error.response.status === 403) {
      notifyMessage("Sorry, your can't access!", 1, 3);
      return dispatch => {
        dispatch(emptyFunction);
      }
    } else {
      notifyMessage("Your connection was interrupted!", 1, 3);
      return dispatch => {
        dispatch(emptyFunction);
      }
    }
  } else {
    notifyMessage("Your connection was interrupted!", 1, 3);
    return dispatch => {
      dispatch(emptyFunction);
    }
  }
};

const emptyFunction = () => {
}


